import { Breadcrumb } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const BreadcrumbLayout = () => {
    const { title } = useSelector(state => state.user);
    const location = useLocation();

    if (location.pathname === '/') {
        return null;
    }

    return (
        <Breadcrumb
            style={{
                margin: '16px 0',
            }}
        >
            <span className='main-title'>{title}</span>
        </Breadcrumb>
    );
};

export default BreadcrumbLayout;